export default "/_next/static/chunks/fonts/din-medium-webfont-c93b906edd961ba964620f78d6beaa3a.woff";